import FlatCard from "components/UI-lib/FlatCard";
import LaunchableConfigurationView from "../shared/LaunchableConfigurationView";
import { dummyInstanceObject } from "components/Environment/utils";
import { Button } from "components/Graphs/Button";
import React from "react";
import LaunchableInteractive from "../../List/LaunchableInteractive";
import { ArrowUpRightIcon } from "@heroicons/react/24/solid";

interface LaunchableAccessErrorProps {
  isPublic: boolean;
  handleLogin?: () => void;
}

export const LaunchableAccessError: React.FC<LaunchableAccessErrorProps> = ({
  isPublic,
  handleLogin,
}) => (
  <>
    <div className="flex flex-row mt-8 justify-center">
      <div className="flex flex-col justify-center">
        <div className="text-red-500 text-sm p-2r ounded font-bold text-xl">
          Launchable Access Error
        </div>
        {isPublic ? (
          <span className="text-sm text-primary font-semibold mt-2">
            This launchable is not public.
          </span>
        ) : (
          <span className="text-sm text-primary font-semibold mt-2">
            You do not have access to this launchable.
          </span>
        )}
        {isPublic && handleLogin && (
          <div className="flex flex-col gap-2">
            <span className="text-sm text-primary font-semibold">
              If you are authorized to access this launchable, click the button
              below to login.
            </span>
            <div className="flex">
              <Button onClick={handleLogin}>
                <span className="text-sm text-white font-semibold">Login</span>
                <ArrowUpRightIcon className="w-4 h-4 text-white ml-2" />
              </Button>
            </div>
          </div>
        )}
      </div>
      <div className="relative">
        <LaunchableInteractive
          isSectionInfoEnabled={false}
          isAnimationEnabled={true}
        />
      </div>
    </div>
  </>
);
